TS.ns('WL');

WL.externalSystemModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);

        var partnerTypesList = me.getDomainProperty('dgPartnerTypeCollection_Property');
        if (partnerTypesList) {
            partnerTypesList.on('addNew', me._onPartnerTypeAdded);
        }

        createHandler = function (rowIDX) {
            var f = rowIDX;
            return function (newValue) {
                me._onAllPartnerTypesChanged(f);
            };
        };

        $.each(me.ExternalSystemCollection(), function (index, cont) {
            me.watchProperty(me.ExternalSystemCollection()[index].AllPartnerTypes, createHandler(index), me);
        })
    },

    createProperties: function (config) {
        var me = this;
        me.parent(config);
        var externalSystemList = me.getDomainProperty('dgExternalSystemCollection_Property');
        if (externalSystemList) {
            externalSystemList.on('selectionChanged', me._onExternalSystemChanged);
            externalSystemList.on('afterAdd', me.onInterrogationAdded, me);
        }
    },

    onInterrogationAdded: function (e) {
        var me = this;

        e.item.IsActive(true);
    },

    _onAllPartnerTypesChanged: function (rowIdx) {
        var me = this;
           
        var partnerTypesList = me.getDomainProperty('dgPartnerTypeCollection_Property');
        var externalSystemList = me.getDomainProperty('dgExternalSystemCollection_Property');
        
        if (partnerTypesList != null) {
            if (externalSystemList.SelectedItem().AllPartnerTypes() == true) {
                //me.performServerCommand({
                //    cmd: 'ClearAllPartnerTypes',
                //    submitModel: true,
                //    extraData: { rowIdx: rowIdx },
                //    blockUI: true
                //});
                var records = $.extend({}, partnerTypesList.records);
                partnerTypesList.records().splice(0, partnerTypesList.records().length);
                partnerTypesList._setRecords(null);
                //externalSystemList.SelectedItem();

                //externalSystemList.selectRow
                externalSystemList.selection(0);

            }
        }
    },

    _onExternalSystemChanged: function (e) {
        var me = this;

        var owner = me._getOwner();
        var externalSystemList = owner.getDomainProperty('dgExternalSystemCollection_Property');
 
    },

    _onPartnerTypeAdded: function (e) {
        var me = this;

        var owner = me._getOwner();
        var externalSystemList = owner.getDomainProperty('dgExternalSystemCollection_Property');
        externalSystemList.SelectedItem().AllPartnerTypes(false);
    }

});